import React from 'react';

// Concept 1: Infinite Spiral - Akasha as infinite knowledge
const LogoConcept1 = () => (
  <svg viewBox="0 0 100 100" className="w-32 h-32" fill="none">
    <defs>
      <linearGradient id="gold1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e8d5a3"/>
        <stop offset="50%" stopColor="#c9a227"/>
        <stop offset="100%" stopColor="#b8922a"/>
      </linearGradient>
    </defs>
    {/* Spiral representing infinite records */}
    <path 
      d="M50 20 Q70 20 70 40 Q70 60 50 60 Q35 60 35 45 Q35 32 50 32 Q60 32 60 45 Q60 55 50 55"
      stroke="url(#gold1)" strokeWidth="3" strokeLinecap="round" fill="none"
    />
    {/* Base/foundation - sostén */}
    <path d="M25 75 Q50 65 75 75" stroke="url(#gold1)" strokeWidth="3" strokeLinecap="round" fill="none"/>
    <circle cx="50" cy="45" r="5" fill="#c9a227"/>
  </svg>
);

// Concept 2: Open Book/Flower - Akashic Records opening
const LogoConcept2 = () => (
  <svg viewBox="0 0 100 100" className="w-32 h-32" fill="none">
    <defs>
      <linearGradient id="gold2" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e8d5a3"/>
        <stop offset="50%" stopColor="#c9a227"/>
        <stop offset="100%" stopColor="#b8922a"/>
      </linearGradient>
      <radialGradient id="glow2" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#c9a227" stopOpacity="0.6"/>
        <stop offset="100%" stopColor="#c9a227" stopOpacity="0"/>
      </radialGradient>
    </defs>
    {/* Glow */}
    <circle cx="50" cy="50" r="30" fill="url(#glow2)"/>
    {/* Petals opening - transformation */}
    <path d="M50 25 Q55 40 50 50" stroke="url(#gold2)" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
    <path d="M30 35 Q42 42 50 50" stroke="url(#gold2)" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
    <path d="M70 35 Q58 42 50 50" stroke="url(#gold2)" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
    <path d="M25 55 Q38 52 50 50" stroke="url(#gold2)" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
    <path d="M75 55 Q62 52 50 50" stroke="url(#gold2)" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
    {/* Center - consciousness */}
    <circle cx="50" cy="50" r="6" fill="#c9a227"/>
    <circle cx="50" cy="50" r="3" fill="#e8d5a3"/>
    {/* Base */}
    <path d="M35 75 Q50 68 65 75" stroke="url(#gold2)" strokeWidth="2" strokeLinecap="round" fill="none"/>
  </svg>
);

// Concept 3: Sphere with A - refined version
const LogoConcept3 = () => (
  <svg viewBox="0 0 100 100" className="w-32 h-32" fill="none">
    <defs>
      <linearGradient id="gold3" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e8d5a3"/>
        <stop offset="50%" stopColor="#c9a227"/>
        <stop offset="100%" stopColor="#b8922a"/>
      </linearGradient>
      <radialGradient id="glow3" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#c9a227" stopOpacity="0.5"/>
        <stop offset="100%" stopColor="#c9a227" stopOpacity="0"/>
      </radialGradient>
    </defs>
    {/* Outer glow */}
    <circle cx="50" cy="50" r="35" fill="url(#glow3)"/>
    {/* Circle */}
    <circle cx="50" cy="50" r="28" stroke="url(#gold3)" strokeWidth="2.5" fill="none"/>
    {/* Elegant A */}
    <path d="M38 65 L50 30 L62 65" stroke="url(#gold3)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M42 55 L58 55" stroke="url(#gold3)" strokeWidth="2.5" strokeLinecap="round"/>
    {/* Light point at top */}
    <circle cx="50" cy="30" r="3" fill="#e8d5a3"/>
  </svg>
);

// Concept 4: Lotus/Transformation - opening consciousness
const LogoConcept4 = () => (
  <svg viewBox="0 0 100 100" className="w-32 h-32" fill="none">
    <defs>
      <linearGradient id="gold4" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e8d5a3"/>
        <stop offset="50%" stopColor="#c9a227"/>
        <stop offset="100%" stopColor="#b8922a"/>
      </linearGradient>
      <radialGradient id="glow4" cx="50%" cy="60%" r="40%">
        <stop offset="0%" stopColor="#c9a227" stopOpacity="0.6"/>
        <stop offset="100%" stopColor="#c9a227" stopOpacity="0"/>
      </radialGradient>
    </defs>
    <circle cx="50" cy="55" r="25" fill="url(#glow4)"/>
    {/* Lotus petals */}
    <path d="M50 30 Q52 45 50 55" stroke="url(#gold4)" strokeWidth="2" fill="none"/>
    <path d="M50 30 Q60 40 55 55" stroke="url(#gold4)" strokeWidth="2" fill="none"/>
    <path d="M50 30 Q40 40 45 55" stroke="url(#gold4)" strokeWidth="2" fill="none"/>
    <path d="M30 50 Q40 52 50 55" stroke="url(#gold4)" strokeWidth="2" fill="none"/>
    <path d="M70 50 Q60 52 50 55" stroke="url(#gold4)" strokeWidth="2" fill="none"/>
    <path d="M25 60 Q38 57 50 55" stroke="url(#gold4)" strokeWidth="2" fill="none"/>
    <path d="M75 60 Q62 57 50 55" stroke="url(#gold4)" strokeWidth="2" fill="none"/>
    {/* Center orb */}
    <circle cx="50" cy="55" r="8" fill="#c9a227"/>
    <circle cx="50" cy="55" r="4" fill="#e8d5a3"/>
    {/* Base line - sostén */}
    <path d="M30 78 Q50 72 70 78" stroke="url(#gold4)" strokeWidth="2" strokeLinecap="round" fill="none"/>
  </svg>
);

// Concept 5: Infinity + Light - Eternal records
const LogoConcept5 = () => (
  <svg viewBox="0 0 100 100" className="w-32 h-32" fill="none">
    <defs>
      <linearGradient id="gold5" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e8d5a3"/>
        <stop offset="50%" stopColor="#c9a227"/>
        <stop offset="100%" stopColor="#b8922a"/>
      </linearGradient>
      <radialGradient id="glow5" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#c9a227" stopOpacity="0.7"/>
        <stop offset="100%" stopColor="#c9a227" stopOpacity="0"/>
      </radialGradient>
    </defs>
    <circle cx="50" cy="50" r="20" fill="url(#glow5)"/>
    {/* Infinity symbol */}
    <path 
      d="M25 50 Q25 35 37 35 Q50 35 50 50 Q50 65 63 65 Q75 65 75 50 Q75 35 63 35 Q50 35 50 50 Q50 65 37 65 Q25 65 25 50"
      stroke="url(#gold5)" strokeWidth="3" strokeLinecap="round" fill="none"
    />
    {/* Central light */}
    <circle cx="50" cy="50" r="6" fill="#c9a227"/>
    <circle cx="50" cy="50" r="3" fill="#e8d5a3"/>
  </svg>
);

// Concept 6: Portal/Gateway - Access to Akasha
const LogoConcept6 = () => (
  <svg viewBox="0 0 100 100" className="w-32 h-32" fill="none">
    <defs>
      <linearGradient id="gold6" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e8d5a3"/>
        <stop offset="50%" stopColor="#c9a227"/>
        <stop offset="100%" stopColor="#b8922a"/>
      </linearGradient>
      <radialGradient id="glow6" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#c9a227" stopOpacity="0.6"/>
        <stop offset="100%" stopColor="#c9a227" stopOpacity="0"/>
      </radialGradient>
    </defs>
    <circle cx="50" cy="50" r="25" fill="url(#glow6)"/>
    {/* Outer arch */}
    <path d="M25 80 L25 40 Q25 15 50 15 Q75 15 75 40 L75 80" stroke="url(#gold6)" strokeWidth="3" strokeLinecap="round" fill="none"/>
    {/* Inner arch */}
    <path d="M35 80 L35 45 Q35 25 50 25 Q65 25 65 45 L65 80" stroke="url(#gold6)" strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.5"/>
    {/* Stylized A inside */}
    <path d="M44 60 L50 40 L56 60" stroke="url(#gold6)" strokeWidth="2" strokeLinecap="round" fill="none"/>
    <path d="M46 55 L54 55" stroke="url(#gold6)" strokeWidth="1.5" strokeLinecap="round"/>
    {/* Light at top */}
    <circle cx="50" cy="40" r="4" fill="#c9a227"/>
    <circle cx="50" cy="40" r="2" fill="#e8d5a3"/>
  </svg>
);

const LogoShowcase = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 p-12">
      <h1 className="text-3xl text-white text-center mb-4">Propuestas de Logo - Escuela de Consciencia Akáshica</h1>
      <p className="text-gray-400 text-center mb-12">Conceptos dorados con líneas simples</p>
      
      <div className="grid grid-cols-2 md:grid-cols-3 gap-12 max-w-4xl mx-auto">
        <div className="text-center">
          <div className="bg-gray-800/50 rounded-2xl p-8 mb-4">
            <LogoConcept1 />
          </div>
          <p className="text-white font-medium">1. Espiral Infinita</p>
          <p className="text-gray-400 text-sm">Registros eternos + sostén</p>
        </div>
        
        <div className="text-center">
          <div className="bg-gray-800/50 rounded-2xl p-8 mb-4">
            <LogoConcept2 />
          </div>
          <p className="text-white font-medium">2. Flor que se Abre</p>
          <p className="text-gray-400 text-sm">Transformación + consciencia</p>
        </div>
        
        <div className="text-center">
          <div className="bg-gray-800/50 rounded-2xl p-8 mb-4">
            <LogoConcept3 />
          </div>
          <p className="text-white font-medium">3. Esfera con A</p>
          <p className="text-gray-400 text-sm">Akasha + luz interior</p>
        </div>
        
        <div className="text-center">
          <div className="bg-gray-800/50 rounded-2xl p-8 mb-4">
            <LogoConcept4 />
          </div>
          <p className="text-white font-medium">4. Loto Dorado</p>
          <p className="text-gray-400 text-sm">Despertar + sostén</p>
        </div>
        
        <div className="text-center">
          <div className="bg-gray-800/50 rounded-2xl p-8 mb-4">
            <LogoConcept5 />
          </div>
          <p className="text-white font-medium">5. Infinito Luminoso</p>
          <p className="text-gray-400 text-sm">Eternidad + centro</p>
        </div>
        
        <div className="text-center">
          <div className="bg-gray-800/50 rounded-2xl p-8 mb-4">
            <LogoConcept6 />
          </div>
          <p className="text-white font-medium">6. Portal Akáshico</p>
          <p className="text-gray-400 text-sm">Como Campus + A integrada</p>
        </div>
      </div>
    </div>
  );
};

export default LogoShowcase;
